import { ICreateReplacementResult, IReplacementSearch } from '../model/IReplacement';
import api from './api';

export interface IReplacementQuery {
  orderId: string;
  itemId: number;
  /** A part number, stock number or tag. Omitted for the similar-parts list. */
  partNumber?: string;
}

// --
// -- Both endpoints are ADMIN-only on the backend, on the controller class.
// --
// -- Note what is NOT sent from here: the interchange number, the price ceiling
// -- and the mileage floor are read off the order server-side, and the
// -- storefront's shared secret never reaches the browser at all. The old
// -- x-connector page fetched that secret and posted it onward from the client,
// -- which put it in the devtools of everyone who used the feature.
// --
export const replacementApi = api.injectEndpoints({
  endpoints: (build) => ({
    // GET /api/v1/orders/{orderId}/items/{itemId}/replacements
    getReplacementCandidates: build.query<IReplacementSearch, IReplacementQuery>({
      query: ({ orderId, itemId, partNumber }) => ({
        url: `orders/${orderId}/items/${itemId}/replacements`,
        params: partNumber ? { partNumber } : undefined,
      }),
    }),

    // POST /api/v1/orders/{orderId}/items/{itemId}/replacements
    //
    // Answers 200 with created:false and the store's own message when it
    // refuses, so a rejection is read from the body rather than caught.
    createReplacement: build.mutation<
      ICreateReplacementResult,
      { orderId: string, itemId: number, pid: string }
    >({
      query: ({ orderId, itemId, pid }) => ({
        url: `orders/${orderId}/items/${itemId}/replacements`,
        method: 'POST',
        body: { pid },
      }),
      // The new order is a different order; this one is untouched. Orders
      // lists are invalidated so it shows up in them.
      invalidatesTags: ['Orders'],
    }),
  }),
});
